import { Button, Flex, Typography } from '@aloft/toolkit-sui';

import { useState } from 'react';

export const ImageCarousel = ({ urls }: { urls: string[] }) => {
  const [index, setIndex] = useState(0);
  if (urls.length === 0) return null;
  const current = urls[index]!;
  return (
    <Flex flexDirection="column" gap="8px">
      <Flex alignItems="center" gap="12px">
        <Typography variant="h4">Images ({urls.length})</Typography>
        <Typography variant="body2" color="textSecondary">
          {index + 1} / {urls.length}
        </Typography>
      </Flex>
      <div style={{ position: 'relative', textAlign: 'center' }}>
        <img
          src={current}
          alt={`Property ${index + 1} of ${urls.length}`}
          style={{
            maxWidth: '100%',
            maxHeight: 420,
            borderRadius: 4,
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto',
          }}
        />
        {urls.length > 1 && (
          <Flex justifyContent="space-between" alignItems="center" padding="8px 0" gap="8px">
            <Button
              text="← Prev"
              size="sm"
              variant="secondary"
              onClick={() => setIndex((i) => (i - 1 + urls.length) % urls.length)}
            />
            {/* Thumbnail strip */}
            <div style={{ display: 'flex', gap: 4, overflowX: 'auto', flex: 1, padding: '4px 0' }}>
              {urls.map((url, i) => (
                // eslint-disable-next-line aloft/prefer-sound-ui-button
                <button
                  type="button"
                  key={`thumb-${url}`}
                  onClick={() => setIndex(i)}
                  aria-label={`View property ${i + 1}`}
                  aria-pressed={i === index}
                  style={{
                    padding: 0,
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    flexShrink: 0,
                    outline: i === index ? '2px solid #0066cc' : '2px solid transparent',
                    borderRadius: 3,
                    opacity: i === index ? 1 : 0.65,
                  }}
                >
                  <img
                    src={url}
                    alt={`Property ${i + 1}`}
                    style={{ width: 56, height: 40, objectFit: 'cover', borderRadius: 3, display: 'block' }}
                  />
                </button>
              ))}
            </div>
            <Button
              text="Next →"
              size="sm"
              variant="secondary"
              onClick={() => setIndex((i) => (i + 1) % urls.length)}
            />
          </Flex>
        )}
      </div>
    </Flex>
  );
};
